//todo update to production config
export default {
  apiKey: "AIzaSyA2cQJuFEsJvQUvC1m7Ttw25tyygJBAESw",
  authDomain: "json2ld.mapper.tokyo",
  databaseURL: "https://json2ld-mapper.firebaseio.com",
  projectId: "json2ld-mapper",
  storageBucket: "json2ld-mapper.appspot.com",
  messagingSenderId: "891604457216"
}


// WEBPACK FOOTER //
// ./src/config/firebase.production.js